import React from 'react';
import 'twin.macro';
import { StatsCardsWithData } from 'containers/RegistreAppel/Stats/StatsCards/StatsCardsWithData';
import { ElevesAbsencesListWithData } from './AbsencesList';

interface Props {
  from: Date;
  to: Date;
  eleveId: string;
}

export function Main(props: Props) {
  const { from, to, eleveId } = props;
  return (
    <div tw="mb-12">
      <StatsCardsWithData from={from} to={to} eleveId={eleveId} />
      <ElevesAbsencesListWithData from={from} to={to} eleveId={eleveId} />
    </div>
  );
}
